export default "__VITE_ASSET__DmAzGX51__"